// Copyright (c) 2024 Visual Intelligence LP. All rights reserved.
//
import { injectable } from 'inversify';
import { makeObservable } from 'mobx';

import container from '@core/di';
import { AquaService } from '@shared/services';
import { AquaVIUserDTO } from '@shared/models/aqua-api';


// Expose methods provided by the service component.
@injectable()
export default class AquaStore  {
  static diToken = Symbol('aqua-store');
  private service = container.get<AquaService>(AquaService.diToken);

  // stateful vars.

  constructor() {
    makeObservable(this);
  }

  // Send request to sync an order with data from Aqua.
  // Input: orderName
  // Return:
  //   response from the sync request.
  syncOrder = async (orderName: string): Promise<string | undefined> => {
    try {
      return await this.service.syncOrder(orderName);      
    } 
    catch (error) {
      console.error("****** Exception in Store - syncOrder:", error);
      throw error;      
    }
  }

  // Get Aqua dataset for VI user.  The dataset includes workspace (projects, ...), roles, permissions, etc.
  // Input:
  // Return:
  //   response from the update request.
  getVIUserData = (): Promise<AquaVIUserDTO> => {
    try {
      return this.service.getVIUserData();      
    } 
    catch (error) {
      console.error("****** Exception in Store - syncOrder:", error);
      throw error;      
    }
  }
}